// extracted by mini-css-extract-plugin
module.exports = {"hero":"Login_hero__2zxns","card":"Login_card__2jE7L","logo":"Login_logo__3pV1Q"};